import { render, staticRenderFns } from "./FilteredProductTbody.vue?vue&type=template&id=b81820a4&scoped=true&"
import script from "./FilteredProductTbody.vue?vue&type=script&lang=js&"
export * from "./FilteredProductTbody.vue?vue&type=script&lang=js&"
import style0 from "./FilteredProductTbody.vue?vue&type=style&index=0&id=b81820a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81820a4",
  null
  
)

export default component.exports